import { ScrolledPastWatcher } from 'common/components/scrolled-past-watcher';
import React from 'react';
import { DismissAnimation, TransitionGroup } from './dismiss-animation';
import { OrientationCard } from './orientation-card';
import { SectionHeader, SectionHeaderButton } from './section-header';

import { forTemplate } from 'common/lib/util/i18n';
const l = forTemplate('home');

import styles from './up-next-section.less';

// TODO: TMON-817 Only pass ids down instead of models
interface UpNextModel {
  /* tslint:disable:no-any */
  board: any[];
  card: any[];
  id: string;
  item: any[];
  list: any[];
  org: any[];
  /* tslint:enable:no-any */
}

type RenderUpNext = (upNextModel: UpNextModel) => JSX.Element;

interface UpNextListProps {
  numUpNextCardsVisible: number;
  renderUpNext: RenderUpNext;
  upNextCards: UpNextModel[];
}

const UpNextList: React.StatelessComponent<UpNextListProps> = ({
  numUpNextCardsVisible,
  renderUpNext,
  upNextCards,
}) => (
  <TransitionGroup component="ul" className={styles.upNextCardList}>
    {upNextCards
      .filter((upNextCard, index) => index < numUpNextCardsVisible)
      .map((upNextCard) => (
        <DismissAnimation id={upNextCard.id} key={upNextCard.id}>
          <li key={upNextCard.id} className={styles.upNextCardListItem}>
            {renderUpNext(upNextCard)}
          </li>
        </DismissAnimation>
      ))}
  </TransitionGroup>
);

interface UpNextSectionProps {
  dismissUpNextOrientationCard: () => void;
  newUpNextCards: string[];
  numUpNextCardsVisible: number;
  onShowMoreUpNextClick: () => void;
  renderUpNext: RenderUpNext; // "connected" to modelCache, similarly to using react-redux's `connect`
  setFixedButton: () => void;
  shouldShowUpNextOrientationCard: boolean;
  showNewUpNextItems: () => void;
  upNextCards: UpNextModel[];
}

export class UpNextSection extends React.PureComponent<UpNextSectionProps> {
  render() {
    const {
      dismissUpNextOrientationCard,
      newUpNextCards,
      numUpNextCardsVisible,
      onShowMoreUpNextClick,
      renderUpNext,
      setFixedButton,
      shouldShowUpNextOrientationCard,
      showNewUpNextItems,
      upNextCards,
    } = this.props;

    return (
      <div className={styles.upNextCards}>
        {!!upNextCards.length ? (
          <SectionHeader
            iconName="checkbox-checked"
            button={
              !!newUpNextCards.length && (
                <ScrolledPastWatcher setScrolledPast={setFixedButton}>
                  <SectionHeaderButton onClick={showNewUpNextItems}>
                    {l('show-new-up-next')}
                  </SectionHeaderButton>
                </ScrolledPastWatcher>
              )
            }
          >
            {l('up-next')}
          </SectionHeader>
        ) : (
          <div className={styles.homeNoUpNextCards} />
        )}

        {shouldShowUpNextOrientationCard &&
          !!upNextCards.length && (
            <OrientationCard
              backgroundName="up-next"
              onDismissClick={dismissUpNextOrientationCard}
              textKey="orientation-up-next-text"
              titleKey="orientation-up-next-title"
            />
          )}

        <UpNextList
          numUpNextCardsVisible={numUpNextCardsVisible}
          renderUpNext={renderUpNext}
          upNextCards={upNextCards}
        />

        {upNextCards.length > numUpNextCardsVisible && (
          <DismissAnimation id="show-more">
            <a
              className="show-more u-text-align-center"
              href="#"
              onClick={onShowMoreUpNextClick}
              role="button"
            >
              {l('show-more')}
            </a>
          </DismissAnimation>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/up-next-section.tsx